"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgSkipBack = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 4a1 1 0 0 1 1 1v14a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1ZM17.998 4.08a2 2 0 0 1 1.565.753c.302.379.375.834.406 1.172.031.347.031.785.031 1.28v9.43c0 .495 0 .933-.031 1.28-.031.338-.104.793-.406 1.172a2 2 0 0 1-1.565.752c-.485 0-.886-.228-1.169-.415-.29-.192-.632-.466-1.019-.775L9.91 14.008a10.327 10.327 0 0 1-.65-.548 2.044 2.044 0 0 1-.531-.758 2 2 0 0 1 0-1.404c.125-.334.34-.576.53-.758a10.316 10.316 0 0 1 .679-.57L15.81 5.27c.387-.31.729-.583 1.019-.775.283-.187.684-.415 1.169-.415Z", fill: "currentColor" }) }))); };
exports.default = SvgSkipBack;
